import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableContainer
} from '@mui/material';

import { MessageData } from 'generated/graphql';
import _ from 'lodash';
import { SegmentedTableRow } from 'modules/components/layer22';



export type SegmentedLabelTableProps = {
  data: MessageData;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SegmentedLabelTableProps) => {
  const label2Data = _.groupBy(props.data?.values, (node) => node.label);
  const labels = _.keys(label2Data);

  return (
    <Card>
      <CardContent>
        <TableContainer>
          <Table
            size='small'
            padding='none'
          >
            <TableBody>
              {labels.flatMap((label, i) => {
                const labelRows = label2Data[label];
                return (
                  <SegmentedTableRow.FC
                    key={`${i}`}
                    data={labelRows}
                    label={label}
                    glAccountName={props.data?.displayName ?? ''}
                  />
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

      </CardContent>
    </Card>
  );
};
